import React from 'react';
import { Row, Col, Button } from 'antd';
import { PageAboveTitle, PageDescription, PageTitle } from '../text/Titles';
import { Icon } from '@ant-design/compatible';
import { useHistory } from 'react-router';

type Props = {
  container?: null | string;
  back?: { url: string; label: string };
  header: null | string;
  description?: null | string;
};

export const PageHeader = ({ container, back, header, description }: Props) => {
  let history = useHistory();

  return (
    <Row className="flex-col" style={{ minHeight: '180px' }}>
      {container && (
        <Row style={{ minHeight: '40px' }}>
          <PageAboveTitle>{container.toUpperCase()}</PageAboveTitle>
        </Row>
      )}
      {back && (
        <Row style={{ minHeight: '40px' }}>
          <Button
            type="link"
            size="small"
            className="text-toolbox-primary text-sm flex items-center p-0 mb-4"
            onClick={() => history.push(back.url)}>
            <Icon type="left" />
            <span>{back.label}</span>
          </Button>
        </Row>
      )}
      <Row style={{ minHeight: '60px' }}>
        <PageTitle>{header}</PageTitle>
      </Row>
      {description && (
        <Row className="mt-1 mb-2">
          <Col span={20}>
            <PageDescription>{description}</PageDescription>
          </Col>
        </Row>
      )}
    </Row>
  );
};
